import IUserMenu from '../../interfaces/IUserMenu';
import { resolveMenuPath } from '../resolveMenuPath';

export const flattenMenuPaths = (menus: IUserMenu[] = []): string[] => {
  const paths: string[] = [];

  const extract = (items: IUserMenu[]) => {
    items.forEach(item => {
      const resolved = resolveMenuPath(item);
      if (resolved) {
        paths.push(resolved);
      }
      if (item.children && item.children.length > 0) {
        extract(item.children);
      }
    });
  };

  extract(menus);
  return Array.from(new Set(paths));
};

export default flattenMenuPaths;
